import { combineReducers } from "redux";
import { firebaseReducer } from "react-redux-firebase";
import { firestoreReducer } from "redux-firestore";
import { reducer as formReducer } from "redux-form";

import { AuthReducer } from "./Auth/AuthReducer";
import { CustomersReducer } from "./Customers/CustomersReducer";
import { RegionsReducer } from "./Regions/RegionsReducer";
import { EquipmentsReducer } from "./Equipments/EquipmentsReducer";
import { NotificationsReducer } from "./Notifications/NotificationsReducer";

import { snackbarReducer } from "./snackbar/snackbarReducer";

const rootReducer = combineReducers({
  auth: AuthReducer,
  customers: CustomersReducer,
  equipments: EquipmentsReducer,
  regions: RegionsReducer,
  notifications: NotificationsReducer,
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  form: formReducer,
  snackbar: snackbarReducer,
});

export default rootReducer;
